/* unplugin-vue-components disabled */import { render } from "./View.vue?vue&type=template&id=313feff1&ts=true"
import script from "./View.vue?vue&type=script&lang=ts"
export * from "./View.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./View.vue?vue&type=style&index=0&id=313feff1&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.32_webpack@5.105.4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__